import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Table, Nav, Row, Col } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import Select from "react-select";
import VideoPlayer from "../../Pages/Home/VideoPlayer";

import { Link } from "react-router-dom";

const ArticleSetting = () => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [article, setArticle] = useState([]);

    useEffect(() => {
        getTopArticles();
        getDropDownArticles();
    }, []);

    const getTopArticles = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getTopArticles",
        });

        const output = response.data;

        if (output.length > 0) {
            setRows(output);
        }
    };

    const getDropDownArticles = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getDropDownArticles",
        });

        const output = response.data;

        if (output.length > 0) {
            setArticle(output);
        }
    };

    return (
        <div>
            <div className="table-responsive">
                <h4 className="mb-0">Top 6 Articles Settings</h4>
                <Table striped bordered hover className="table-responsive-scroll mt-2">
                    <thead className="thead-dark">
                        <tr>
                            <th>Multimedia</th>
                            <th>Title</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.pk_ta_key}>
                                <td>
                                    {JSON.parse(row.additionalFields).map((item, index) => {
                                        if (index == 0) {
                                            return item["base_type"] === "video" ? (
                                                <VideoPlayer key={index} src={IMAGE_URL + item["file_name"]} />
                                            ) : (
                                                <img
                                                    key={index}
                                                    width={100}
                                                    className="img-fluid"
                                                    src={IMAGE_URL + item["file_name"]}
                                                    alt="Article Img"
                                                />
                                            );
                                        }
                                    })}
                                </td>
                                <td>{row.ac_name}</td>
                                <td>{row.status === 1 ? "Draft" : row.status === 2 ? "Published" : "Archieved"}</td>
                                <td>
                                    <Button
                                        as={Link}
                                        to={`/admin/edit-articlesettings/${row.pk_ta_key}`}
                                        className="edit-icon btn btn-outline-dark"
                                        data-bs-toggle="tooltip"
                                        title="Edit"
                                    >
                                        <i class="fa-solid fa-pen-to-square"></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default ArticleSetting;
